import httpClient from "http-client/http-client";

export function normalizePhoneNumber(phone) {
  return String(phone || "").replace(/\D/g, "");
}

export async function sendSignupOtp(phoneNumber, type = "REGISTRATION") {
  const { data, errors } = await httpClient.post({
    url: "v1/community-portal/auth/send-otp",
    body: { phone_number: normalizePhoneNumber(phoneNumber), type },
  });
  if (errors && errors.length > 0) return { data: null, errors };
  return { data };
}

export async function registerPortal({
  name,
  phone_number,
  otp,
  account_types,
  email_id,
  initial_application,
}) {
  const { data, errors } = await httpClient.post({
    url: "v1/community-portal/auth/register",
    body: {
      name,
      phone_number: normalizePhoneNumber(phone_number),
      otp,
      account_types,
      email_id,
      initial_application,
    },
  });
  if (errors && errors.length > 0) return { data: null, errors };
  return { data };
}
